/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * ホットスポットを押したときの動作（ADR-0022）。
SEEK=同じ動画の指定位置へ / VIDEO_TRANSITION=別の動画ノードへ / EXTERNAL_LINK=外部リンク
 */
export type HotspotActionType = (typeof HotspotActionType)[keyof typeof HotspotActionType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotspotActionType = {
  SEEK: 'SEEK',
  VIDEO_TRANSITION: 'VIDEO_TRANSITION',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
} as const
